let forms = require( './forms' );
let order_review = require( './order-review' );

let donation_form = (function( $ ) {

	let $form;

	let _init = function() {
		$form = $( '#donation_form' );

		if ( $form.length > 0 ) {
			_setup_field();

			$form.on( 'form_submitted', _form_submitted );
		}
	};

	let _setup_field = function() {
		let $field = $form.find( 'input[name="donation_form-donation_amount"]' );

		$field.wrap( '<div id="donation-wrap"/>' );

		let $wrap = $form.find( '#donation-wrap' );

		$wrap.prepend( '<span class="pound">&pound;</span>' );
		$wrap.append( '<a href="#" class="button save-form" data-form="donation_form" data-savesource="donation">Donate</a>' );

		forms.init_save_buttons();
	};

	let _form_submitted = function( e, response ) {
		if ( response.manual_save ) {
			forms.display_field_errors( $form, response.field_errors );
			forms.display_field_notices( $form, response.field_notices );

			if ( response.valid ) {
				order_review.update_order_review_html();
			}
		}
	};

	$( document ).ready( _init );

	return {};

})( jQuery );

module.exports = donation_form;